import SellitemFullTable from './SellitemFullTable';

export default SellitemFullTable;
